export const MISMATCHED_FUNCTIONAL_UNIT_NAMES = new Map([
  ["CAPDefaults", "CashAppDefaults"],
  ["CashInBanks", "CashInBank"],
  ["CREDefaults", "CashReceiptDefaults"],
  ["COA", "ChartOfAccounts"],
  ["EtcTechPayrollRecordTypes", "EtcTechPayRecTypes"],
  ["GroupCodes", "ReportGroupCodes"],
  ["Checks", "OnDemandChecks"],
  ["RecurringJournalEntries", "RecurringJrnlEntries"],
  ["VendorCompany", "VendorCompanyType"],
  ["PartsEmployees", "Employees"],
  ["PTSOSOC", "PtsOptChargeAccounts"],
  ["PMUFieldMaps", "PartsMasterUpdateMap"],
  ["Opcodes", "OpCodes"],
  ["ServicePaymentTypes", "PaymentTypes"],
  ["PaymentTypes", "CashReceiptPymtTypes"],
]);

export const UPDATED_SETUP_LABELS = new Map([
  ["RemitToParent", "Vendor Remit To Parent"],
  ["Invoice Auto Post", "AP Invoice Auto Post"],
  ["Cash Clearing Setup", "Simple Pay Cash Clearing"],
  ["Cash App Defaults", "CAP Cash App Defaults"],
]);

export const SETUP_DESCRIPTIONS = new Map([
  [
    "vendorCompanyTypeTab",
    "Add company types that vendors can be classified under. You can add as many as needed.",
  ],
  [
    "vendorCategoryTab",
    "Add categories that vendors can be classified under. You can add as many as needed.",
  ],
  [
    "vendorPaymentTypesTab",
    "Configure payment methods with their categories and requirements.",
  ],
]);

export const FUNCTIONAL_AREA_SEARCH_URL_MAP = new Map<string, string>([
  ["/v2/search/COA", "accounting"],
  ["/v2/search/Journals", "accounting"],
  ["/v2/search/CNumCompanyMapping", "accounting"],
  ["/v2/search/Make", "accounting"],
  ["/v2/search/Model", "accounting"],
  ["ServiceInvoice", "Invoice"],
]);

//for Top/Header Setups Navigation
export const DEPENDENT_SETUPS_MAP: Map<
  string,
  { id: string; text: string; setupsList: string[] }[]
> = new Map([
  [
    "accounting",
    [
      {
        id: "APSetups",
        text: "AP Setups",
        setupsList: [
          "AccountsPayable",
          "Checks",
          "RemitToParent",
          "InvoiceAutoPost",
          "LaserFormTable",
          "RemittanceFormMapping",
          "TruckAPInvoices",
        ],
      },
      {
        id: "ARSetups",
        text: "AR Setups",
        setupsList: [
          "AccountsReceivable",
          "CAPDefaults",
          "CREDefaults",
          "PaymentTypes",
          "ARPortal",
        ],
      },
      {
        id: "GLSetups",
        text: "GL Setups",
        setupsList: [
          "SaleChains",
          "CashInBanks",
          "COA",
          "ExpenseAllocations",
          "CashClearingSetup",
          "GLFiscalYearCalendar",
          "GLCalendar",
          "GLFiscalYearEnd",
          "IntercoTransfer",
          "WriteOffs",
          "GroupCodes",
          "BankRecon",
          "Journals",
          "JournalTemplates",
          "RecurringJournalEntries",
        ],
      },
      {
        id: "ETCSubgroup",
        text: "ETC Setups",
        setupsList: [
          "EtcAbsenceCodes",
          "EtcPayPeriod",
          "EtcTardyCodes",
          "EtcTimeZones",
          "EtcTechPayrollRecordTypes",
          "ETCTimeZonesMasterData",
          "EtcHolidays",
          "EtcPayrollFields",
          "ETCTimesheetDeclaration",
        ],
      },
      {
        id: "POSetups",
        text: "PO Setups",
        setupsList: [
          "POConfigurationGroup",
          "PORoleLevelInfo",
          "POUnitsOfMeasure",
          "POVendorChangeControl",
        ],
      },
      {
        id: "VendorSetups",
        text: "Vendor Setups",
        setupsList: [
          "VendorCategory",
          "VendorCompanyType",
          "VendorPaymentTypes",
          "VendorConfigurationGroup",
        ],
      },
    ],
  ],
]);

export const SETUP_PERMISSIONS_MAP = new Map<
  string,
  { view: string; manage: string; import?: string }
>([
  // AP Setups
  ["AccountsPayable", { view: "SETUPS_AP_VIEW", manage: "SETUPS_AP_MANAGE" }],
  ["Checks", { view: "SETUPS_AP_VIEW", manage: "SETUPS_AP_MANAGE" }],
  ["RemitToParent", { view: "SETUPS_AP_VIEW", manage: "SETUPS_AP_MANAGE" }],
  ["InvoiceAutoPost", { view: "SETUPS_AP_VIEW", manage: "SETUPS_AP_MANAGE" }],
  ["LaserFormTable", { view: "SETUPS_AP_VIEW", manage: "SETUPS_AP_MANAGE" }],
  [
    "RemittanceFormMapping",
    { view: "SETUPS_AP_VIEW", manage: "SETUPS_AP_MANAGE" },
  ],
  [
    "TruckAPInvoices",
    {
      view: "SETUPS_TRUCK_AP_INVOICES_VIEW",
      manage: "SETUPS_TRUCK_AP_INVOICES_MANAGE",
    },
  ],

  // AR Setups
  [
    "AccountsReceivable",
    { view: "SETUPS_AR_VIEW", manage: "SETUPS_AR_MANAGE" },
  ],
  ["CAPDefaults", { view: "SETUPS_AR_VIEW", manage: "SETUPS_AR_MANAGE" }],
  ["CREDefaults", { view: "SETUPS_AR_VIEW", manage: "SETUPS_AR_MANAGE" }],
  ["PaymentTypes", { view: "SETUPS_AR_VIEW", manage: "SETUPS_AR_MANAGE" }],
  ["ARPortal", { view: "SETUPS_AR_VIEW", manage: "SETUPS_AR_MANAGE" }],

  // GL Setups - (Note: COA, CashClearingSetup are special cases and have their own permissions)
  [
    "COA",
    {
      view: "SETUPS_COA_VIEW",
      manage: "SETUPS_COA_MANAGE",
      import: "SETUPS_COA_IMPORT",
    },
  ],
  [
    "CashClearingSetup",
    {
      view: "SETUPS_CASH_CLEARING_VIEW",
      manage: "SETUPS_CASH_CLEARING_MANAGE",
    },
  ],
  ["SaleChains", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["CashInBanks", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  [
    "ExpenseAllocations",
    { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" },
  ],
  [
    "GLFiscalYearCalendar",
    { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" },
  ],
  ["GLCalendar", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["GLFiscalYearEnd", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["IntercoTransfer", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["WriteOffs", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["GroupCodes", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["BankRecon", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["Journals", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  ["JournalTemplates", { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" }],
  [
    "RecurringJournalEntries",
    { view: "SETUPS_GL_VIEW", manage: "SETUPS_GL_MANAGE" },
  ],

  // ETC Setups
  ["EtcAbsenceCodes", { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" }],
  ["EtcPayPeriod", { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" }],
  ["EtcTardyCodes", { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" }],
  ["EtcTimeZones", { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" }],
  [
    "EtcTechPayrollRecordTypes",
    { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" },
  ],
  [
    "ETCTimeZonesMasterData",
    { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" },
  ],
  ["EtcHolidays", { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" }],
  [
    "EtcPayrollFields",
    { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" },
  ],
  [
    "ETCTimesheetDeclaration",
    { view: "SETUPS_ETC_VIEW", manage: "SETUPS_ETC_MANAGE" },
  ],

  // PO Setups
  [
    "POConfigurationGroup",
    { view: "SETUPS_PO_VIEW", manage: "SETUPS_PO_MANAGE" },
  ],
  ["PORoleLevelInfo", { view: "SETUPS_PO_VIEW", manage: "SETUPS_PO_MANAGE" }],
  ["POUnitsOfMeasure", { view: "SETUPS_PO_VIEW", manage: "SETUPS_PO_MANAGE" }],
  [
    "POVendorChangeControl",
    { view: "SETUPS_PO_VIEW", manage: "SETUPS_PO_MANAGE" },
  ],

  // Vendor Setups
  [
    "VendorCategory",
    { view: "SETUPS_VENDOR_VIEW", manage: "SETUPS_VENDOR_MANAGE" },
  ],
  [
    "VendorCompanyType",
    { view: "SETUPS_VENDOR_VIEW", manage: "SETUPS_VENDOR_MANAGE" },
  ],
  [
    "VendorPaymentTypes",
    { view: "SETUPS_VENDOR_VIEW", manage: "SETUPS_VENDOR_MANAGE" },
  ],
  [
    "VendorConfigurationGroup",
    { view: "SETUPS_VENDOR_VIEW", manage: "SETUPS_VENDOR_MANAGE" },
  ],

  // FixedOps Setups
  [
    "InventoryBuildings",
    {
      view: "SETUPS_INVENTORY_BUILDING_LOCATIONS_VIEW",
      manage: "SETUPS_INVENTORY_BUILDING_LOCATIONS_MANAGE",
    },
  ],
  [
    "CustomPricing",
    {
      view: "SETUPS_HEAVY_TRUCK_PRICING_VIEW",
      manage: "SETUPS_HEAVY_TRUCK_PRICING_MANAGE",
    },
  ],
  [
    "SystemNotifications",
    {
      view: "SETUPS_SYSTEM_NOTIFICATIONS_VIEW",
      manage: "SETUPS_SYSTEM_NOTIFICATIONS_MANAGE",
    },
  ],
  [
    "PricingMatrix",
    {
      view: "SETUPS_PRICE_BREAK_ESCALATOR_VIEW",
      manage: "SETUPS_PRICE_BREAK_ESCALATOR_MANAGE",
      import: "SETUPS_PRICE_BREAK_ESCALATOR_IMPORT",
    },
  ],
]);

export const ENUM_DISPLAY_MAPPINGS: Record<
  string,
  Record<string, Record<string, string>>
> = {
  CashClearingSetup: {
    integrating_application: {
      cdkservice: "CDK Service",
      driveparts: "Drive Parts",
      driveservice: "Drive Service",
      driveaccounting: "Drive Accounting",
      modernretailing: "Modern Retailing",
      virtualterminal: "Virtual Terminal",
      legacyfi: "Drive F&I",
      modparts: "CDK Parts",
      modacc: "Accounting Modernized",
    },
    transaction_type: {
      ACH: "Bank Account",
      CC: "Credit Card",
      BUY_NOW_PAY_LATER: "Buy Now Pay Later",
    },
  },
};
